<h2 class="mb-6">How do you want to set this up?</h2>

<mat-radio-group [value]="selectedOption()" (change)="onOptionChange($event.value)" class="flex flex-col space-y-4">
  @for (option of cleaningOptions(); track option.value) {
    <div
      class="grid"
      [class.cursor-pointer]="!option.disabled"
      [class.cursor-not-allowed]="option.disabled"
      (click)="onOptionClick(option.value, option.disabled)">
      <mat-radio-button [value]="option.value" [disabled]="option.disabled" uiRadioWrapped class="w-full">
        <div class="flex flex-col">
          <div class="flex items-center gap-2">
            <span
              class="font-medium text-base"
              [class.text-text-primary]="!option.disabled"
              [class.text-[rgba(0,0,0,.38)]]="option.disabled"
              >{{ option.label }}</span
            >
            @if (option.recommended && !option.disabled) {
              <ui-badge value="Recommended" variant="success" size="sm" appearance="subtle" />
            }
          </div>
          <span
            class="text-sm mt-1 font-normal"
            [class.text-text-secondary]="!option.disabled"
            [class.text-[rgba(0,0,0,.38)]]="option.disabled"
            >{{ option.description }}</span
          >
        </div>
      </mat-radio-button>
    </div>
  }
</mat-radio-group>
